export interface ExcelService {
  parseXlsx<T>(rawData: Uint8Array, options: ParseOptions): Promise<T[]>
}

interface ParseOptions {
  fileType: string
  asArray?: boolean
}
const DEFAULT_PARSE_OPTIONS = {
  asArray: false
} as const

export const excelService: ExcelService = {
  async parseXlsx<T>(rawData: Uint8Array, options: ParseOptions): Promise<T[]> {
    const opts = {
      ...DEFAULT_PARSE_OPTIONS,
      ...options
    }

    const { parseAsJSON } = await import(/* webpackChunkName: "exceljs" */ './exceljs')

    const exceljsOutput = await parseAsJSON(rawData, opts)
    return exceljsOutput as T[]
  }
}
